"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var Observable_1 = require("rxjs/Observable");
var sis_control_with_settings_1 = require("./sis-control-with-settings");
var formatting_service_1 = require("../../service/formatting.service");
var Subject_1 = require("rxjs/Subject");
var SisDecimalComponent = /** @class */ (function (_super) {
    __extends(SisDecimalComponent, _super);
    function SisDecimalComponent(formattingService) {
        var _this = _super.call(this) || this;
        _this.formattingService = formattingService;
        _this.isReadonly = false;
        //
        _this.valueChange = new core_1.EventEmitter();
        _this.ngUnsubscribe = new Subject_1.Subject();
        return _this;
    }
    SisDecimalComponent.prototype.ngOnInit = function () {
    };
    Object.defineProperty(SisDecimalComponent.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            if (value || value === 0) {
                this._value = value + '';
                this.checkValue(false, true);
            }
            else {
                this._value = '';
            }
        },
        enumerable: true,
        configurable: true
    });
    SisDecimalComponent.prototype.changeValue = function (value) {
        if (value || value === 0) {
            this._value = value + '';
            this.checkValue(true, true);
        }
        else {
            this._value = '';
            this.valueChange.emit(null);
        }
    };
    SisDecimalComponent.prototype.handleKeyPress = function (evt) {
        if (this._value && (evt.which < 48 || evt.which > 57) && evt.which != 46) {
            var eventTarget = evt.target;
            var selection = this._value.substring(eventTarget.selectionStart, eventTarget.selectionEnd);
            if (!((evt.which === 45 && eventTarget.selectionStart === 0 &&
                (this._value.indexOf('-') === -1 || selection.indexOf('-') !== -1)))) {
                evt.preventDefault();
            }
        }
    };
    SisDecimalComponent.prototype.getIsReadonly = function () {
        return this.isReadonly;
    };
    SisDecimalComponent.prototype.checkValue = function (emit, format) {
        var _this = this;
        if (this._value === '-') {
            return;
        }
        if (this._value === '') {
            this.valueChange.emit(null);
            return;
        }
        this.formattingService.parseNumber(this._value).mergeMap(function (number) {
            if (isNaN(number)) {
                return Observable_1.Observable.of(number);
            }
            else {
                if (format) {
                    return _this.formattingService.formatNumber(number).map(function (formatted) {
                        _this._value = formatted;
                        return number;
                    });
                }
                else {
                    return Observable_1.Observable.of(number);
                }
            }
        }).takeUntil(this.ngUnsubscribe).subscribe(function (number) {
            if (isNaN(number)) {
                _this.valueChange.emit(null);
                _this._value = '';
                return;
            }
            if (emit) {
                _this.valueChange.emit(number);
            }
        }, console.error);
    };
    SisDecimalComponent.prototype.ngOnDestroy = function () {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    SisDecimalComponent.decorators = [
        { type: core_1.Component, args: [{
                    selector: 'sis-portfolio-decimal',
                    template: "\n               <ng-container *ngIf=\"!getIsReadonly()\">\n                 <mat-form-field class=\"sis-form-field\" color=\"accent\" [floatLabel]=\"'never'\"\n                                 [hintLabel]=\"_hint | sisTranslateMultilingual | async\">\n                   <input matInput [(ngModel)]=\"_value\" [id]=\"id\" (blur)=\"checkValue(false, true)\"\n                          (keypress)=\"handleKeyPress($event)\" (change)=\"changeValue($event.target.value)\"\n\t\t\t\t\t\t  (keyup)=\"checkValue(true, false)\">\n                 </mat-form-field>\n               </ng-container>\n               <ng-container *ngIf=\"getIsReadonly()\">\n                 <span *ngIf=\"value\"> {{value}} </span>\n                 <span *ngIf=\"!value\" class=\"sis-no-data\"> {{\"de_no_data\" | sisTranslateMessage | async}} </span>\n               </ng-container>\n             ",
                },] },
    ];
    /** @nocollapse */
    SisDecimalComponent.ctorParameters = function () { return [
        { type: formatting_service_1.PortfolioFormattingService, },
    ]; };
    SisDecimalComponent.propDecorators = {
        "id": [{ type: core_1.Input },],
        "isReadonly": [{ type: core_1.Input },],
        "valueChange": [{ type: core_1.Output },],
        "value": [{ type: core_1.Input },],
    };
    SisDecimalComponent = __decorate([
        idm_dynamic_controls_metadata_1.ControlMetadata({
            name: 'Decimal',
            template: "\n                        <sis-portfolio-integer [id]=\"'%{id}'\" [(value)]=\"%{field}\" [isReadonly]=\"%{isReadonly}\" [hint]=\"%{hint}\">\n                        </sis-portfolio-integer>\n                   ",
            cellCount: 3,
            isFieldBound: true,
        }),
        __metadata("design:paramtypes", [formatting_service_1.PortfolioFormattingService])
    ], SisDecimalComponent);
    return SisDecimalComponent;
}(sis_control_with_settings_1.SisControlWithSettings));
exports.SisDecimalComponent = SisDecimalComponent;
//# sourceMappingURL=sis-decimal.component.js.map